// import 'babel-polyfill';
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/zh';
import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
// import { AppContainer } from 'react-hot-loader';fA
import '@axa-asia/web-toolkit-css';
import logPreviousUrl from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';
import EmmaGaListener from '@axa-asia/hk-emma-web-module/lib/ga-lib/EmmaGaListener';
import { getScreenNameAsync } from '@axa-asia/hk-emma-web-module/lib/ga-lib/WebScreenNameMappingUtil';
import { maskPN } from '@axa-asia/hk-emma-web-module/lib/ga-lib/MaskingUtil';
import {
  gaClickableElementCallback,
  logPreviousUrlCallback,
  trackDefaultPageView,
} from './services/analyticsEvents';
import createStore from './redux/createStore';
import RootContainer from './RootContainer';
import '@axa-asia/emma-stylesheet/styles/frontend.scss';
import '@axa-asia/emma-stylesheet/lib/index.css';
import './styles/global.scss';
import { getPlatformStr } from './utils/GaPreviousScreenUtil';
import { gaScreenNameMapping } from './constants/gaScreenNameMapping';
import { trackDefaultPageViewGA4 } from './services/firebaseAnalyticsEvents';
import { retryFnCall } from './utils/retryUtil';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { startAppInsight } from './utils/appInsights';
import { isMobileBrowser } from '@axa-asia/utils';

// Start app insights
startAppInsight();

const initialState = window.___INITIAL_STATE__ || {}; // eslint-disable-line
const { store, syncedHistory } = createStore(browserHistory, initialState);
const rootElement = document.getElementById('root');

if (!isMobileBrowser()) {
  import('@axa-asia/emma-stylesheet/styles/common/scrollbar.scss');
  const root = document.getElementsByTagName('html')[0];
  root.className += 'axa-scrollbar';
}

if (rootElement) {
  const render = (Root) => {
    document.domain = window.location.hostname.split('.').slice(-3).join('.');
    ReactDOM.render(
      // <AppContainer>
      <Root store={store} history={syncedHistory} />,
      // </AppContainer>,
      rootElement,
    );
  };

  // if (module.hot) {
  //   module.hot.accept('./RootContainer', () => {
  //     const NextApp = require('./RootContainer').default; // eslint-disable-line
  //     render(NextApp);
  //   });
  // }

  // Create emmaGa when the app init
  const emmaGa = new EmmaGaListener();
  emmaGa.serve([gaClickableElementCallback]);

  const platformStr = getPlatformStr();
  logPreviousUrl(
    logPreviousUrlCallback,
    browserHistory,
    platformStr,
    gaScreenNameMapping,
  );

  browserHistory.listen(() => {
    trackDefaultPageView(window.location.pathname); // GA3
  });

  // send default page view to Ga when init the app
  const maskedCurrScreenPath = maskPN(window.location.pathname);
  EmmaFactory.createInstance().then((emma) => {
    emma.instance.getPreviousScreen().then((prevPathName) => {
      getScreenNameAsync(
        maskedCurrScreenPath,
        platformStr,
        gaScreenNameMapping,
      ).then((currScreenName) => {
        const maskedCurrScreenName = maskPN(currScreenName);
        retryFnCall(
          () => {
            trackDefaultPageView(maskedCurrScreenPath); // GA3
            trackDefaultPageViewGA4(
              maskedCurrScreenName,
              prevPathName,
              maskedCurrScreenPath,
            ); // GA4
          },
          5,
          3000,
        );
      });
    });
  });

  // When logout or application destory:
  // emmaGa.destory()

  render(RootContainer);
}
